export const GROWTHBOOK_FEATURES_KEYS = {
    SHOW_ZARA_BASKET_NAV: "cart.nav.is-zara-basket-tab-enabled",
    SHOW_ZARA_FAVORITES_NAV: "cart.nav.is-favorite-tab-enabled",
    COOKIES_CONSENT_ENABLED_APPS: "cookies.consent.is-cookies-consent-enabled-apps",
    NEW_SEARCH_API_VERSION: "api.search.is-new-version-available",
    ALT_TEXT_RECOVERY_ENABLED: "accessibility.images.alt-text-recovery-is-enabled",
    NEW_UNIVERSES_ENDPOINT_VERSION: "api.universes.is-new-version-available",
    SELL_IS_NEW_FLOW_ENABLED: "sell.nav.is-new-flow-enabled",
    MULTIPLE_IMAGES_CAPTURE_MIN_VERSION: "sell.images.multiple-capture-min-app-version",
    NEW_UPLOAD_IMAGES_FLOW_ENABLED: "sell.image.upload-image-ia-new-flow-is-enabled",
    NEW_FILTER_SEARCH_API_ENABLED: "api.search.is-filter-get-endpoint-activate",
    SAFE_IMAGE_RESIZE_ENABLED: "sell.image.safe-resize-decode-is-enabled",
    WITHOUT_ALTERING_IMAGE: "sell.image.without-altering-process",
    UNIVERSE_EDITORIAL_IMAGES: "universe.grid.editorial-images",
    UNIVERSE_BANNER_IMAGES: "universes.grid.banner-images",
    SEARCH_IMAGE_SEARCH_ENABLED: "search.image-search.enabled",
    SEARCH_IMAGE_SHOP_LOOK_SEARCH_ENABLED: "search.image-shop-look-search.enabled",
    SEARCH_LANDING_PROMOTIONAL_BANNER: "search.landing.promotional-banner",
    ORIGINAL_IMAGE_UPDATE_ENDPOINT: "sell.original-image-endpoint.is-active",
    JFIF_TO_JPEG_CONVERSION_ENABLED: "sell.image.jfif-to-jpeg-conversion-is-enabled",
    CREATE_IMAGE_BITMAP_RESIZE_ENABLED: "sell.image.create-image-bitmap-resize-is-enabled",
    WELCOME_CARD_PROMOTIONAL_BANNER: "welcome.card.promotional-banner",
    PRESERVE_EXIF_ON_RESIZE_ENABLED: "sell.image.preserve-exif-on-resize-is-enabled",
    RELOAD_PURCHASES_ON_VISIBILITY_CHANGE: "orders.purchases.reload-on-visibility-change",
    NEW_IMAGE_UPLOAD_ENABLED: "sell.image.upload-endpoint.is-active",
}


export const GROWTHBOOK_TARGET_VARIANTS = {
    ANDROID: "android",
    IOS: "ios",
    WEB_DESKTOP: "web_desktop",
    WEB_MOBILE: "web_mobile"
}